import application_settings from "../applicationSettings";
import Event from "./Event";
import LocalStorage from '../local_data';

class GetOfferCategories extends Event {
  eventName = "oms_getOfferCategories";

  constructor() {
    super();
    this.add();
  }

  /**
   *
   *
   *
   */
  eventFunction(data) {
   
    let clientId = data.client_id;
    let thisObj = this;
    let requestId = data.request_id ? data.request_id : "";
    let action = data.action ? data.action : "";
    let start = data.start;
    let locationId = !data.all_location_data
      ? new LocalStorage.CurrentLocation(clientId).getData()
      : null;

    // request data
    data.endPoint = application_settings.endPoints.GetOfferCategories;

    data.data = {
      client_id: clientId,
      location_id: locationId,
      request_id: requestId,
      limit: data.limit,

      start: start,
      sort_property: data.sort_property,
      sort_direction: data.sort_direction,
      filter_groups: data.filters,
    };

    // send request
    this.sendRequest(data, function (response) {
      if (response) {
        //format response data
        let data = thisObj.formatResponseData(response);

        //fire success event
        thisObj.onSuccessEvent(data, { action: action, request_id: requestId });
      }
    });
  }
}

export default GetOfferCategories;
